// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0671df92","453":"92d61893"}[chunkId] + ".chunk.js";
};